import Listingcards from "./Listingcards";
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/config";
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from "react";
import ReactPaginate from 'react-paginate';
import Overlay from '../components/Overlay';
import Spinner from "react-activity/dist/Spinner";
import { useDebouncedCallback } from 'use-debounce';
import Helmet from "react-helmet";
import { getRoundedDiscountAmount, getRoundedDiscountPercent, getRoundedSellingPrice, roundNumber } from "../utils/price";

const TurnTableListing = () => {
  const { subcategory, category } = useParams();
  const [genredata, setgenredata] = useState([]);
  const [selectedgenre, setselectedgenre] = useState("");
  const [selectedlanguage, setselectedlanguage] = useState("");
  const [selectsearch, setselectsearch] = useState("");
  const [subcategorydata, setsubcategorydata] = useState([]);

  const [productsdata, setproductsdata] = useState([]);
  const [showloding, setshowloding] = useState(false);
  const navigate = useNavigate();

  const [currentpage, setcurrentpage] = useState(0);
  const currentpageRef = useRef(0);
  currentpageRef.current = currentpage;

  const productsRef = useRef(0);
  productsRef.current = productsdata;

  //pagination
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setpageCount] = useState(0);
  const [itemsPerPage, setitemsPerPage] = useState(8);
  const [currentItems, setcurrentItems] = useState(0);

  useEffect(() => {
    if(productsdata.length > 0) {
      setcurrentpage(0);
      const newOffset = (0 * itemsPerPage) % productsdata.length;
    var catedata = productsdata.slice(newOffset, newOffset + itemsPerPage)
    setcurrentItems(productsdata.slice(newOffset, newOffset + itemsPerPage));
    setpageCount(Math.ceil(productsdata.length / itemsPerPage));
    setItemOffset(newOffset);
    }
    
  }, [itemsPerPage])


  const handlePageClick = (event) => {
    console.log('handlePageClick event >>', event);
    // console.log('old itemOffset >>', itemOffset);
    // console.log('itemsPerPage >>', itemsPerPage);
    // console.log('productsdata?.length >>', productsdataRef.current?.length);
    setcurrentpage(event.selected);
    const newOffset = (event.selected * itemsPerPage) % productsRef.current?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setcurrentItems(productsRef.current?.slice(newOffset, newOffset + itemsPerPage));
    setpageCount(Math.ceil(productsRef.current.length / itemsPerPage));
    setItemOffset(newOffset);
    // scroll to top
    window.scrollTo({
      top: 100,
      behavior: 'smooth', // Enables smooth scrolling
    });
  };

  const handlechangepagecount = (num) => {
    setitemsPerPage(parseInt(num))
  }

  const Items = ({ currentItems }) => {
    console.log('currentItems11 >>', currentItems.length);
    return (
      <>
      {
        currentItems?.length > 0 ?
        currentItems?.map((item, index) => {
                console.log('item >>', item)
                var proimage = null;
                if(item?.image1) {
                  proimage = item?.image1;
                } else if(item?.image2) {
                  proimage = item?.image2;
                } else if(item?.image3) {
                  proimage = item?.image3;
                } else if(item?.image4) {
                  proimage = item?.image4;
                } else if(item?.image5) {
                  proimage = item?.image5;
                } else if(item?.image6) {
                  proimage = item?.image6;
                } else if(item?.image7) {
                  proimage = item?.image7;
                } else if(item?.image8) {
                  proimage = item?.image8;
                } else {
                  proimage = null;
                }

                //percent
                // var discountpercent = item?.discount_percent ? parseInt(item?.discount_percent) : 0;
                // var discountpercent = item?.discountprice ? parseInt(item?.discountprice) : 0;
                // var discountpercent = 0;
                // if(item?.discount_percent && item?.discountprice) {
                //   if(parseInt(item?.discount_percent) > parseInt(item?.discountprice)) {
                //     discountpercent = parseInt(item?.discount_percent);
                //   } else if(parseInt(item?.discount_percent) < parseInt(item?.discountprice)) {
                //     discountpercent = parseInt(item?.discountprice);
                //   } else {
                //     discountpercent = parseInt(item?.discountprice);
                //   }
                // } else if(item?.discount_percent) {
                //   discountpercent = parseInt(item?.discount_percent);
                // } else if(item?.discountprice) {
                //   discountpercent = parseInt(item?.discountprice);
                // } else {
                //   discountpercent = 0;
                // }

                let discountpercent = getRoundedDiscountPercent(item.discount_percent, item.dealdiscount, item.discountprice);

                console.log('discountpercent >>', discountpercent)
                
                var price = item?.price;
                var discountprice = discountpercent > 0 ? getRoundedDiscountAmount(price, discountpercent) : 0;
                var sellingprice = getRoundedSellingPrice(price, discountpercent);
                var originalprice = roundNumber(price);
                return (
                  <div className="col-md-3" key={index}>
                  <div style={{cursor: 'pointer'}} onClick={() => {handlenavigation(item)}}>
                    <div className="card-img">
                      <div className="align-items-center d-flex justify-content-center img-border">
                        <img class="img-fluid" src={assetsUrl + 'products/'+proimage} />
                        <div className="listingsoldoutdiv">
                                  {
                                    item?.stock < 1 ?
                                    <span style={{backgroundColor: '#e61513', color: '#fff', padding: 5,
                                      position: 'absolute', bottom: 0, right: 0, fontSize: 15
                                    }} >SOLD OUT</span> : null
                                  }
                                  </div>
                      </div>
                      <div className="card-img-text img-text">
                        <p class="price listing_title" style={{color: '#000'}}>
                          <span class="artist_name">{item?.composer}</span>
                          {item?.brand ? (
                            <>
                              <span className="turntable-listing-brand">{item.brand}</span><br />
                            </>
                          ) : null}
                          <span class="product_name fontweight600">{item.name}</span><br />
                          <span class="formate_name">{item?.formate} </span>&nbsp;
                          <span class="product-price">₹{sellingprice}</span> 
                          {
                            discountpercent > 0 ? 
                            <span class="clr">
                            <s>₹{originalprice}</s>
                          </span> : null
                          }
                         
                          {
                            discountpercent > 0 ?
                            <span className="offer"><br />{discountpercent}% OFF</span> : null
                          }
                          
                        </p>
                        <div class="price-detail price-box">
                  {
                    discountprice > 0 ?
                    <span class="dicount-amount">Save ₹{discountprice}</span> :
                    null
                  }
                                

                                  
                                  
                                  </div>
                                 
                      </div>
                    </div>
                  </div>
                </div>
                  
                )
              })
            : 
            showloding ?
            <Spinner color='#f8a41a' size={30} className='spinnerCenteroffer' /> :

            <p class="price" style={{color: '#000'}}>
            <span class="artist_name">No Products</span>

          </p>
      }
      
      </>
    );
  }


  const fetchdashboarddata = async(subcat) => {
    setshowloding(true);
    const data = {
      subcategory: subcat,
      category: category
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
          .post(apiUrl + "getgenrelist",data, headers)
          .then((res) => {
            // console.log('getdashboarddata res >>', res.data)
            if(res?.data?.status == 'success') {
              console.log('data >>', res?.data);
              setgenredata(res?.data?.data);

              // console.log('products length >>', res?.data?.products?.length);
            }
          })
          .catch((err) => {
            alert(err.message);
          });
    setshowloding(false);
    
  }

  const filterproducts = async(genre, language, text) => {
    var data = {
      subcategory: subcategory,
      category: category,
      genre: genre,
      language: language,
      searchtext: text,
      device: 'web'
    }
    console.log('test data >>', data)
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
          .post(apiUrl + "fetchproductsbyfilter",data, headers)
          .then((res) => {
            // console.log('getdashboarddata res >>', res.data)
            if(res?.data?.status == 'success') {
              console.log('products length >>', res?.data?.products?.length);
              
              var catdata = res?.data?.products
              setcurrentItems(catdata.slice(itemOffset, itemsPerPage));
              setpageCount(Math.ceil(catdata.length / itemsPerPage));
              setproductsdata(res?.data?.products);
              setItemOffset(0);
            } else {
              setproductsdata([]);
            }
          })
          .catch((err) => {
            alert(err.message);
          });
    setshowloding(false);
  }

  const handlenavigation = (data) => {
    console.log('data >>', data)
    // navigate('/entertainment/'+data?.slug)
    window.open('/entertainment/'+data?.slug, '_blank');
  }

  const debouncedFetch = useDebouncedCallback((selectedgenre1, selectedlanguage1, selectsearch1) => filterproducts(selectedgenre1, selectedlanguage1, selectsearch1), 500);

  useEffect(() => {
    // filterproducts(selectedgenre, selectedlanguage, selectsearch);
    debouncedFetch(selectedgenre, selectedlanguage, selectsearch);
  }, [selectedgenre, selectedlanguage, selectsearch, subcategory])


  useEffect(() => {
    // console.log('subcategory >>',subcategory)
    fetchdashboarddata(subcategory);
  }, [subcategory])

  console.log('subcategory >>', subcategory);

  return (
    <section className="pd50">
      {subcategory == "Vinyl-Hindi" ? (
        <Helmet>
          {/* 🌟 Meta Tags for SEO */}
          <title>Hindi & Bollywood Vinyl Records Online | Blisstainment</title>
          <meta
            name="description"
            content="Shop Hindi film soundtracks, Bollywood LPs, ghazals and Indian pop vinyl records. Explore new releases, pre-books and collector editions with India-wide shipping."
          />
          <meta name="author" content="Blisstainment" />

          {/* ✅ Primary Keyword */}
          <meta name="keywords" content="Hindi vinyl records" />

          {/* ✅ Canonical Tag */}
          <link
            rel="canonical"
            href="https://www.blisstainment.com/sub-category/Vinyl-Hindi/Music"
          />

          {/* ✅ Open Graph (OG) Tags - For Social Media */}
          {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}
        </Helmet>
      ) : subcategory == "Vinyl-Tamil" ? (
        <Helmet>
          {/* 🌟 Meta Tags for SEO */}
          <title>Tamil Vinyl Records Online | AR Rahman & Classics</title>
          <meta
            name="description"
            content="Browse Tamil vinyl records, film soundtracks and collector LPs from iconic composers and artists. Shop black, coloured and pre-book editions online in India."
          />
          <meta name="author" content="Blisstainment" />

          {/* ✅ Primary Keyword */}
          <meta name="keywords" content="Tamil vinyl records" />

          {/* ✅ Canonical Tag */}
          <link
            rel="canonical"
            href="https://www.blisstainment.com/sub-category/Vinyl-Tamil/Music"
          />

          {/* ✅ Open Graph (OG) Tags - For Social Media */}
          {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}
        </Helmet>
      ) : subcategory == "Vinyl-English" ? (
        <Helmet>
          {/* 🌟 Meta Tags for SEO */}
          <title>English Vinyl Records Online in India | Blisstainment</title>
          <meta
            name="description"
            content="Shop English vinyl records across rock, jazz, blues, pop, hip-hop and more. Browse imported, collector and classic LPs with secure India-wide delivery."
          />
          <meta name="author" content="Blisstainment" />

          {/* ✅ Primary Keyword */}
          <meta name="keywords" content="English vinyl records India" />

          {/* ✅ Canonical Tag */}
          <link
            rel="canonical"
            href="https://www.blisstainment.com/sub-category/Vinyl-English/Music"
          />

          {/* ✅ Open Graph (OG) Tags - For Social Media */}
          {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}
        </Helmet>
      ) : subcategory == "pre-owned-vinyl" ? (
        <Helmet>
          {/* 🌟 Meta Tags for SEO */}
          <title>Pre-Owned Vinyl Records Online in India | Blisstainment</title>
          <meta
            name="description"
            content="Explore pre-owned and vintage vinyl records in India with condition details, collector notes and secure delivery. Find rare LPs before they sell out."
          />
          <meta name="author" content="Blisstainment" />

          {/* ✅ Primary Keyword */}
          <meta name="keywords" content="Pre owned vinyl records India" />

          {/* ✅ Canonical Tag */}
          <link
            rel="canonical"
            href="https://www.blisstainment.com/sub-category/pre-owned-vinyl/Music"
          />

          {/* ✅ Open Graph (OG) Tags - For Social Media */}
          {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}
        </Helmet>
      )
      : subcategory == "vinyl-accesories" ? (
        <Helmet>
          {/* 🌟 Meta Tags for SEO */}
          <title>Vinyl Record Accessories Online in India | Blisstainment</title>
          <meta
            name="description"
            content="Shop vinyl record accessories including cleaning, storage and care essentials. Protect your LP collection and keep records sounding their best."
          />
          <meta name="author" content="Blisstainment" />

          {/* ✅ Primary Keyword */}
          <meta name="keywords" content="Vinyl record accessories India" />

          {/* ✅ Canonical Tag */}
          <link
            rel="canonical"
            href="https://www.blisstainment.com/sub-category/vinyl-accesories/Music"
          />

          {/* ✅ Open Graph (OG) Tags - For Social Media */}
          {/* <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:url" content="" />
        <meta property="og:image" content=""/>
        <meta property="og:type" content="website" /> */}
        </Helmet>
      ) :
      (
        <Helmet>
          {/* 🌟 Meta Tags for SEO */}
          <title>Buy Vinyl Records Online in India | Blisstainment</title>
          <meta
            name="description"
            content="Shop Hindi, Tamil, English and pre-owned vinyl records, CDs and accessories at Blisstainment. Discover new releases, pre-books and collector LPs across India."
          />
          <meta name="author" content="Blisstainment" />

          {/* ✅ Primary Keyword */}
          <meta name="keywords" content="buy vinyl records online India" />

          {/* ✅ Canonical Tag */}
          <link rel="canonical" href="" />

          {/* ✅ Open Graph (OG) Tags - For Social Media */}
          {/* <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:url" content="" />
                <meta property="og:image" content=""/>
                <meta property="og:type" content="website" /> */}
        </Helmet>
      )}

      <div className="container">
        {subcategory == "vinyl-english" || subcategory == "vinyl-hindi" ? (
          <h1 className="pageheading mt20 uppercase">Indian Vinyl Records</h1>
        ) : subcategory ? (
          <h1 className="pageheading mt20 uppercase" style={{marginBottom: 10}}>
            {subcategory.replace("-", " ")}
          </h1>
        ) : null}

        {/* {
          !showloding ?
          <> */}
        <div className="dflex space-between dblock">
          {/* <div className="selectbox dflex dblock">
            <select
              className="lang uppercase"
              value={selectedgenre}
              onChange={(t) => {
                setselectedgenre(t.target.value);
              }}
            >
              <option value={""} selected>
                All GENRE
              </option>
              {genredata?.length > 0
                ? genredata?.map((item, index) => {
                    return (
                      <option key={index} value={item.name}>
                        {item.name}
                      </option>
                    );
                  })
                : null}
            </select>

            <select
              className="lang ml30 uppercase"
              value={selectedlanguage}
              onChange={(t) => {
                setselectedlanguage(t.target.value);
              }}
            >
              <option value={""} selected>
                All LANGUAGE
              </option>
              <option value="HINDI">HINDI</option>
              <option value="MARATHI">MARATHI</option>
              <option value="ENGLISH">ENGLISH</option>
              <option value="GUJRATI">GUJRATI</option>
              <option value="MALAYALAM">MALAYALAM</option>
              <option value="TAMIL">TAMIL</option>
              <option value="KANNADA">KANNADA</option>
              <option value="BENGALI">BENGALI</option>
              <option value="PUNJABI">PUNJABI</option>
              <option value="BHOJPURI">BHOJPURI</option>
              <option value="TELUGU">TELUGU</option>
              <option value="SANSKRIT">SANSKRIT</option>
            </select>
          </div> */}

          <div className="searchbox" style={{marginLeft: 'auto'}}>
            <input
              value={selectsearch}
              onChange={(t) => {
                setselectsearch(t.target.value);
              }}
              type="search"
              className="searchboxinput"
              placeholder="Search"
            />
          </div>
        </div>

        {!showloding ? (
          <>
            <div className="row justify-content-center">
              <Items currentItems={currentItems} />
            </div>
            <div className="paginatemaindiv">
              <ReactPaginate
                breakLabel="..."
                nextLabel=">>"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="<<"
                renderOnZeroPageCount={null}
                className="custompaginate"
                forcePage={currentpage}
              />
              <select
                class="form-select paginatedropdown"
                value={itemsPerPage}
                onChange={(t) => {
                  handlechangepagecount(t.target.value);
                }}
              >
                <option value="8">8</option>
                <option value="12">12</option>
                <option value="24">24</option>
                <option value="48">48</option>
              </select>
            </div>
          </>
        ) : (
          <Spinner color="#f8a41a" size={30} className="spinnerCenteroffer" />
        )}

        {/* </> :
          <Spinner color='#f8a41a' size={30} className='spinnerCenteroffer' />
        } */}
      </div>
    </section>
  );
};

export default TurnTableListing;
